<app-deny-time-off-request-dialog
    [name]="timeOffRequest.employee.fullName"
    headerTitle="{{ 'time-off-v3.denyTimeOffRequest' | translate }}"
    [timeOffDates]="
        {
            key: 'time-off-v3.dateRangeWithTo',
            params: { startDate: timeOffRequest.startAtString, endDate: timeOffRequest.endAtString },
        } | appTranslate
    "
    primaryButtonLabel="{{ 'time-off-v3.denyRequest' | translate }}"
    [openDialog]="isDenyRequestCommentModalOpen"
    (confirmDenyRequest)="onConfirmDenyRequest($event)"
    (closeDenyRequestModal)="onCloseDenyRequestModal()"
>
</app-deny-time-off-request-dialog>
<div class="wrapper">
    <h2 class="title">{{ 'time-off-v3.approvalFlow' | translate }}</h2>
    <div class="steps">
        <!--Creation Step-->
        <div class="step">
            <div class="indicator">
                <div class="circle fulfilled">
                    <mat-icon svgIcon="check"></mat-icon>
                </div>
                <div class="line"></div>
            </div>
            <div class="text fulfilled">
                <div class="primary">
                    <span>{{ 'time-off-v3.requestCreated' | translate }}</span>
                </div>
                <div class="secondary">
                    {{
                        'time-off-v3.byNameOnDate'
                            | translate
                                : {
                                      name: timeOffRequest.createdBy.fullName,
                                      date: timestampToString(timeOffRequest.createdAt),
                                  }
                    }}
                </div>
            </div>
        </div>
        <!--Force Approval Step-->
        <ng-template [ngIf]="!!timeOffRequest.timeOffRequestApprovalFlow.forcedBy" [ngIfElse]="approvalSteps">
            <app-force-approval-step [approvalFlow]="timeOffRequest.timeOffRequestApprovalFlow">
            </app-force-approval-step>
        </ng-template>

        <!--Approval Steps-->
        <ng-template #approvalSteps>
            <!--Auto Approved-->
            <div
                class="step"
                *ngIf="timeOffRequest.timeOffRequestApprovalFlow.isAutomatic && timeOffRequest.approved; else steps"
            >
                <div class="indicator">
                    <div class="circle fulfilled">
                        <mat-icon svgIcon="check"></mat-icon>
                    </div>
                </div>
                <div class="text fullfilled">
                    <div class="primary">
                        <span>{{ 'time-off-v3.automaticApproval' | translate }}</span>
                    </div>
                    <div class="secondary">
                        {{ timeOffRequest.timeOffRequestApprovalFlow.updatedAt | appDate: 'longDate' }}
                    </div>
                </div>
            </div>
            <ng-template #steps>
                <div
                    *ngFor="
                        let requestApprovalFlowStep of timeOffRequest.timeOffRequestApprovalFlow
                            .timeOffRequestApprovalFlowStepsWithTrashed;
                        let i = index
                    "
                >
                    <div
                        class="step"
                        *ngIf="!requestApprovalFlowStep.isTrashed; else trashedTimeOffRequestApprovalFlowStep"
                    >
                        <div class="indicator">
                            <div
                                class="circle"
                                [class.fulfilled]="requestApprovalFlowStep.approved === true"
                                [class.denied]="requestApprovalFlowStep.approved === false"
                            >
                                <mat-icon svgIcon="check" *ngIf="requestApprovalFlowStep.approved === true"></mat-icon>
                                <mat-icon svgIcon="close" *ngIf="requestApprovalFlowStep.approved === false"></mat-icon>
                            </div>
                            <div
                                class="line"
                                *ngIf="
                                    i <
                                    timeOffRequest.timeOffRequestApprovalFlow.timeOffRequestApprovalFlowStepsWithTrashed
                                        .length -
                                        1
                                "
                            ></div>
                        </div>
                        <div class="text" [class.fulfilled]="requestApprovalFlowStep.approved !== null">
                            <div class="primary">
                                <span
                                    *ngIf="
                                        requestApprovalFlowStep.timeOffApprovalFlowStep.timeOffApproverTypeId !==
                                            specificPersonApprovalId;
                                        else specificPerson
                                    "
                                >
                                    {{
                                        requestApprovalFlowStep.timeOffRequestApprovals[0].isBackupApprover
                                            ? ('time-off-v3.backup' | translate)
                                            : requestApprovalFlowStep.timeOffApprovalFlowStep.timeOffApproverType.name
                                    }}
                                </span>
                                <ng-template #specificPerson>
                                    <span>
                                        {{
                                            requestApprovalFlowStep.timeOffRequestApprovals[0].isBackupApprover
                                                ? ('time-off-v3.backup' | translate)
                                                : (getSpecificPersonApproverName(requestApprovalFlowStep)
                                                  | appTranslate)
                                        }}</span
                                    >
                                </ng-template>
                                <span>{{ ' ' }}{{ 'time-off-v3.approval' | translate }}</span>
                            </div>

                            <div
                                class="secondary"
                                *ngIf="requestApprovalFlowStep.approved === null; else alreadyApprovedOrDenied"
                                [innerHTML]="
                                    'time-off-v3.awaitingApprovalFromSpecificPerson'
                                        | translate
                                            : {
                                                  person:
                                                      (getSpecificPersonApproverName(requestApprovalFlowStep)
                                                      | appTranslate),
                                              }
                                        | sanitizeHtml
                                "
                            ></div>

                            <ng-container
                                *ngIf="
                                    auth.isAdmin() &&
                                    requestApprovalFlowStep.approved === null &&
                                    requestApprovalFlowStep.timeOffRequestApprovals[0].isBackupApprover
                                "
                            >
                                <div class="secondary margin-top-2">
                                    {{
                                        'time-off-v3.theIntendedApproverIsNotActiveOrAnApproverHasNotBeenAssigned'
                                            | translate
                                    }}
                                </div>
                                <a
                                    uiLink
                                    href="https://humi.zendesk.com/hc/en-us/articles/4411058160151"
                                    (click)="trackLearnMoreBackupApprover()"
                                    class="columns-3 small-columns-6 secondary"
                                    target="_blank"
                                    >{{ 'time-off-v3.learnMoreAboutBackupApprovers' | translate }}
                                </a>
                            </ng-container>

                            <ng-template #alreadyApprovedOrDenied>
                                <div class="secondary">
                                    {{
                                        requestApprovalFlowStep.approved
                                            ? ('time-off-v3.approved' | translate)
                                            : ('time-off-v3.denied' | translate)
                                    }}
                                    {{
                                        'time-off-v3.byNameOnDate'
                                            | translate
                                                : {
                                                      name: getApproverName(requestApprovalFlowStep),
                                                      date: getApprovalTimestamp(requestApprovalFlowStep),
                                                  }
                                    }}
                                </div>
                                <div
                                    *ngIf="
                                        !requestApprovalFlowStep.approved &&
                                        requestApprovalFlowStep.timeOffRequestApprovals[0].timeOffComment
                                    "
                                    class="deny-comment"
                                >
                                    <div class="flex comment">
                                        &ldquo;{{
                                            requestApprovalFlowStep.timeOffRequestApprovals[0].timeOffComment.comment
                                        }}&rdquo;
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                    <ng-template #trashedTimeOffRequestApprovalFlowStep>
                        <div class="step">
                            <div class="indicator">
                                <div
                                    class="circle"
                                    [class.fulfilled]="requestApprovalFlowStep.approved === true"
                                    [class.denied]="requestApprovalFlowStep.approved === false"
                                >
                                    <mat-icon
                                        svgIcon="check"
                                        *ngIf="requestApprovalFlowStep.approved === true"
                                    ></mat-icon>
                                    <mat-icon
                                        svgIcon="close"
                                        *ngIf="requestApprovalFlowStep.approved === false"
                                    ></mat-icon>
                                </div>
                                <div
                                    class="line"
                                    *ngIf="
                                        i <
                                        timeOffRequest.timeOffRequestApprovalFlow
                                            .timeOffRequestApprovalFlowStepsWithTrashed.length -
                                            1
                                    "
                                ></div>
                            </div>
                            <div class="text" [class.fulfilled]="requestApprovalFlowStep.approved !== null">
                                <div class="primary">
                                    <span>{{ 'time-off-v3.removedApprovalStep' | appTranslate }}</span>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </ng-template>
        </ng-template>
    </div>
    <div class="buttons" *ngIf="userIsApprover">
        <ui-button name="denyButton" type="outline" [disabled]="!isViewerTurn()" (click)="onDeny()"
            >{{ 'time-off-v3.deny' | translate }}
        </ui-button>
        <ui-button name="approveButton" type="primary" [disabled]="!isViewerTurn()" (click)="onApprove()"
            >{{ 'time-off-v3.approve' | translate }}
        </ui-button>
    </div>
    <div class="buttons" *ngIf="isRequestingEmployee() && timeOffRequest.status === 'denied'">
        <ui-button
            name="createButton"
            type="primary"
            [routerLink]="['/time-off', 'v3', 'requests', 'create']"
            (click)="trackCreateNewRequest()"
            >{{ 'time-off-v3.createNewRequest' | translate }}</ui-button
        >
    </div>
</div>
